import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../../../config/firebase";
import { useNavigate } from "react-router-dom";
import "./AdminHeader.css";

function AdminHeader() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/admin-login");
  };

  return (
    <header className="admin-header-bar">
      <div className="admin-header-logo">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L3 5v6c0 5 3.7 9.7 9 11 5.3-1.3 9-6 9-11V5l-9-3z" fill="#D4AF37" />
        </svg>
        <span className="admin-header-title">Uma Design Admin</span>
      </div>
      <div className="admin-header-actions">
        <span className="admin-header-greeting">Hello, Admin</span>
        <button className="admin-header-logout" onClick={handleLogout}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 17v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1" stroke="#4A4A4A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7 12h10m0 0-3-3m3 3-3 3" stroke="#4A4A4A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Logout
        </button>
      </div>
    </header>
  );
}

export default AdminHeader;
